module.exports = "<ngx-loading [show]=\"loading\"></ngx-loading>\n<div class=\"card-header\">\n    <h4 class=\"card-title\">Ingreso de proveedor</h4>\n    <hr>\n</div>\n\n<div class=\"card-content\">\n\t<app-proveedor-frm-add></app-proveedor-frm-add>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/compras/proveedor-add/proveedor-add.component.html
// module id = ../../../../../src/app/components/compras/proveedor-add/proveedor-add.component.html
// module chunks = main